module.exports = __webpack_public_path__ + "static/img/logo-1.e49d240.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-1.png
// module id = Uls6
// module chunks = 8